import React from "react";
import "./ProfileCard.scss";

const ProfileCard = () => {
  return (
    <div className="profile-page">
      <div className="profile-card">
        <h1 className="profile-title">事業プロフィール</h1>

        <p className="profile-motto">
          社会における様々な仕組みの最適化のため、社会貢献のため
          <br />
          自らが有する少しの経験とスキルを活かすことを目指しています。
        </p>

        <div className="profile-section">
          <h2>概要</h2>
          <table>
            <tbody>
              <tr>
                <th>事業所名</th>
                <td>京都最適化研究社（個人事業）</td>
              </tr>
              <tr>
                <th>事業開始</th>
                <td>2022年10月</td>
              </tr>
              <tr>
                <th>所在地</th>
                <td>京都府南部</td>
              </tr>
              <tr>
                <th>電話番号</th>
                <td className="masked">
                  <a href="tel:07091258435">070-9125-8435</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="profile-section">
          <h2>事業内容（予定のものが多いです）</h2>
          <ul className="business-list">
            <li>Webサイト・Webアプリケーションの企画・開発</li>
            <li>小規模な業務効率化ツールの設計・開発（自動化・データ整理）</li>
            <li>既存システム・業務フローに関する相談</li>
            <li>小規模事業者向けIT導入・運用に関する相談</li>
            <li>各種デジタルコンテンツの制作・運用支援</li>
            <li>広域災害時における保険鑑定</li>
            <li>動画制作</li>
            <li>各種建築関係の品質向上、業務効率化等に係る業務</li>
            <li>ネット回線変更等におけるパソコン等のネットワーク機器の設定</li>
            <li>京町家や古民家の文化的価値を維持向上する取組への支援</li>
            <li>社会最適化に向けた各種活動の企画と運営</li>
          </ul>
        </div>
        <div className="profile-section">
          <h2>保有資格等</h2>
          <ul className="qualification-list">
            <li>
              <span className="qualification-name">一級建築士</span>
            </li>
            <li>
              <span className="qualification-name">
                三級損害保険鑑定人（専門鑑定人A）
              </span>
            </li>
            <li>
              <span className="qualification-name">京都検定 2級</span>
            </li>
            <li>
              <span className="qualification-name">将棋 五段</span>
            </li>
            <li>
              <span className="qualification-name">ヘボテニス週三回</span>
            </li>
            <li>
              <span className="qualification-name">
                過去にフルマラソン（最高記録3時間38分）
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
